import React from 'react';
import PropTypes from 'prop-types';

export default function ArrowUp({ width, height, color }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="attributeArrow"
    >
      <path
        d="M7.02316 0.00212757C7.25681 0.00172922 7.48325 0.0727359 7.66316 0.202822L13.6632 4.56576C13.8674 4.71387 13.9958 4.9267 14.0202 5.15744C14.0446 5.38817 13.9629 5.61791 13.7932 5.7961C13.6234 5.9743 13.3795 6.08636 13.1151 6.10764C12.8507 6.12891 12.5874 6.05765 12.3832 5.90954L7.02316 2.00035L1.66316 5.76993C1.56087 5.84241 1.44318 5.89654 1.31684 5.9292C1.1905 5.96186 1.05801 5.97241 0.92698 5.96025C0.795952 5.94809 0.668969 5.91345 0.553332 5.85832C0.437696 5.8032 0.335684 5.72868 0.253161 5.63904C0.161582 5.54932 0.0922225 5.44406 0.0494299 5.32986C0.00663724 5.21566 -0.00866556 5.09498 0.0044775 4.97538C0.0176206 4.85578 0.0589264 4.73984 0.12581 4.63482C0.192693 4.5298 0.283712 4.43796 0.393163 4.36506L6.39316 0.150467C6.57825 0.0409438 6.80006 -0.0112848 7.02316 0.00212757Z"
        fill={color}
      />
    </svg>
  );
}

ArrowUp.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};

ArrowUp.defaultProps = {
  color: '#000',
  width: 15,
  height: 7,
};
